<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockAdjustment.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('stockAdjustment.pageTitle'),
            href: '/admin/stock-adjustments',
          },
          {
            text: $t('create'),
            active: true,
          },
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <ts-loading-banner :loading="loading">
          <div class="row">
            <div class="col-md-9">
              <ProductList v-model="model" @loading="(val) => loading = val" />
              <label class="ts-shadow-rounded ts-uppercase ts-p-2 ts-rounded-md">{{ $t('stockAdjustment.item') }}</label>
              <ProductDetail 
                v-model="model" 
                :validate="errors"
                @loading="(value) => loading = value" 
              />
            </div>
                        <div class="col-md-3">
              <div
                class="
                  ts-bg-gray-200
                  ts-border-blue-500
                  ts-rounded-md
                  ts-p-3
                  ts-space-y-3
                "
              >
                <div>
                  <label class="required">{{
                    $t('stockAdjustment.adjustmentDate')
                  }}</label>

                  <a-date-picker
                    v-model="model.adjustment_date"
                    format="DD-MM-YYYY"
                    valueFormat="DD-MM-YYYY"
                    class="ts-w-full"
                    @change="() => (model.sub_item_list = [])"
                  ></a-date-picker>
                  <div class="validate" v-if="errors.has('adjustment_date')">
                    {{ errors.first('adjustment_date') }}
                  </div>
                </div>
                <div>
                  <label class="required">{{
                    $t('stockAdjustment.approvedBy')
                  }}</label>
                  <a-select
                    v-model="model.approved_by"
                    :options="userList"
                    showSearch
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    class="ts-w-full"
                  ></a-select>
                  <div class="validate" v-if="errors.has('approved_by')">
                    {{ errors.first('approved_by') }}
                  </div>
                </div>
                <div>
                  <label class="required">{{
                    $t('stockAdjustment.acknowledgeBy')
                  }}</label>
                  <a-select
                    v-model="model.acknowledge_by"
                    :options="userList"
                    showSearch
                    :filterOption="
                      (input, option) =>
                        option.componentOptions.children[0].text
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                    "
                    class="ts-w-full"
                  ></a-select>
                  <div class="validate" v-if="errors.has('acknowledge_by')">
                    {{ errors.first('acknowledge_by') }}
                  </div>
                </div>
                <div>
                  <label>{{ $t('stockAdjustment.remarks') }}</label>
                  <textarea
                    v-model.trim="model.remaks"
                    rows="6"
                    class="form-control"
                  ></textarea>
                </div>
              </div>
            </div>
          </div>
          <div class="row ts-mt-4">
            <div class="col-md-12 ts-space-x-4 ts-flex ts-justify-end">
              <ts-button @click.prevent="$router.push({ name: 'adjustment' })">{{
                $t('cancel')
              }}</ts-button>
              <ts-button
                color="primary"
                :waiting="waiting"
                @click.prevent="onUpdate"
                >{{ $t('update') }}</ts-button
              >
            </div>
          </div>
        </ts-loading-banner>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
import moment from 'moment'
import { Errors } from 'form-backend-validation'
import { mapActions, mapGetters, mapState } from 'vuex'
import ProductDetail from './components/item-detail'
import ProductList from './components/product-list.vue'
export default {
  name: 'adjustmentEdit',
  components: {
    ProductDetail,
    ProductList
  },
  data() {
    return {
      errors: new Errors(),
      loading: false,
      waiting: false,
      model: {
        stock_adjustment_id: null,
        adjustment_date: moment().format('DD-MM-YYYY'),
        acknowledge_by: null,
        approved_by: null,
        remaks: null,
        sub_item_list: [],
      },
    }
  },
  async created() {
    this.loading = true
    await this.fetchResource().finally(() => (this.loading = false))
    await this.find(this.$route.params.id)
    this.setEditData()
  },
  computed: {
    ...mapGetters('stock/adjustment', ['getUom']),
    ...mapState('stock/adjustment', ['edit_data']),
    userList() {
      return this.$store.state.stock.adjustment.users.map((el) => ({
        value: el.user_id,
        label: el.employee.employee_name_en,
      }))
    },
  },
  methods: {
    ...mapActions('stock/adjustment', ['fetchResource', 'update', 'find']),
    onUpdate() {
      this.waiting = true
      this.errors = new Errors()
      this.update({
        id: this.$route.params.id,
        data: this.model,
      })
        .then((response) => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'adjustment' })
        })
        .catch((error) => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    setEditData(){
      if(!_.isEmpty(this.edit_data)) {
        this.model.stock_adjustment_id = this.edit_data.stock_adjustment_id
        this.model.adjustment_date = this.edit_data.adjustment_date
        this.model.acknowledge_by = this.edit_data.acknowledge_by
        this.model.approved_by = this.edit_data.approved_by
        this.model.remaks = this.edit_data.remaks
        this.model.sub_item_list = []

        this.edit_data.details.forEach(el => {
          // push product to state
			    this.$store.commit('stock/adjustment/SET_PRODUCT',{
            uom_cat_id: el.product.uom_cat_id,
            product_id: el.product_id,
            sale_code: el.sale_code,
            uom_category: el.product.uom_category
          })

          this.model.sub_item_list.push({
            product_id: el.product_id,
            product_name_en: el.product_name_en,
            barcode: el.barcode,
            uom_id: el.uom_id,
            uom_name_en: this.getUom(el.product_id).uom_name_en,
            current_qty: el.current_qty,
            new_qty: el.new_qty,
            qty_different: el.different_qty,
            reason: el.reason
          })
        });
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/adjustment/CLEAR_SETUP')
    this.$store.commit('stock/adjustment/SET_EDIT_DATA', {})
    next()
  },
}
</script>